import React from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router";

import { formatTime, viewModes } from "../../common/common";

import SearchSuggest from "../../common/searchsuggest";

import { IcLocationSearch, IcCalendarSearch, IcChevrLeft } from "../../common/svg";
import DateBox from "../../common/datebox";

const QuicklySearch = (props) => {
	const {
		carFinding,
		visible,
		viewMode,
		addressPlaceHolder,
		
		isCalendar,
		onAddressChange,
		onSelectAddress,
		onDateRangeChange,
		openCalendar,
		searchCar,
		hideCalendar,
		onStartTimeChange,
		onEndTimeChange,
		indexUrl,
		prevUrl
	} = props;

	const { startDate,
		endDate,
		startTime,
		endTime } = props.carFinding.filter;


	return (
		<div className={`finding-section ${viewMode === viewModes.LIST ? "fixed" : ""} ${visible ? "" : "scroll-top"}`}>
			<div className="m-container">
				<div className="finding-container" id="home-sd" style={{ position: "relative" }}>
					<a className="wrap-svg back" onClick={() => {
							if (prevUrl !== "") {
								window.location.href = prevUrl;
							} else {
								props.history.back()}
							}
						}>
						<IcChevrLeft />
					</a>
					<div className="finding-info">
						<div className="input-form is-focused">
							<div className="wrap-svg">
								<IcLocationSearch />
							</div>
							<SearchSuggest
								sd={true}
								inputProps={{
									value: carFinding.filter.address,
									onChange: onAddressChange,
									// onFocus: this.onAddressFocus,
									placeholder: addressPlaceHolder,
								}}
								focusAddress={true}
								onSelect={(address) => onSelectAddress(address)}
							/>
						</div>

				
							<div className="time-form" style={{ position: "relative" }} onClick={openCalendar}>
								<div className="time-form__item">
									<div className="wrap-svg">
										<IcCalendarSearch />
									</div>
									

									<div className="time-value">
										{startTime >= 0 ? formatTime(startTime) :  carFinding.filter.startTime ? formatTime(carFinding.filter.startTime) : 'Chọn giờ'},{" "}
										{startDate
											? startDate.format("DD/MM/YYYY")
											: carFinding.filter.startDate
											? carFinding.filter.startDate.format("DD/MM/YYYY")
											: "Chọn ngày"}{" "}
										- {endTime >= 0 ? formatTime(endTime) : carFinding.filter.endTime ? formatTime(carFinding.filter.endTime) : 'Chọn giờ'},{" "}
										{endDate
											? endDate.format("DD/MM/YYYY")
											: carFinding.filter.endDate
											? carFinding.filter.endDate.format("DD/MM/YYYY")
											: "Chọn ngày"}
									</div>

									{/* <div className="time-value">
														{startDate
															? startDate.format("DD/MM/YYYY")
															: carFinding.filter.startDate.format("DD/MM/YYYY")}
													</div>
													<div className="line" />
													<div className="time-value">
														{startDate
															? startDate.format("HH:mm")
															: carFinding.filter.startDate.format("HH:mm")}
													</div> */}
								</div>
								{/* <div className="wrap-svg">
													<IcNextCircle />
												</div>
												<div className="time-form__item">
													<div className="time-value">
														{endDate
															? endDate.format("DD/MM/YYYY")
															: carFinding.filter.endDate.format("DD/MM/YYYY")}
													</div>
													<div className="line" />
													<div className="time-value">{endDate ? endDate.format("HH:mm") : "Chọn giờ"}</div>
												</div> */}
							</div>
					
							{/* //<DateRangePicker
							// 	initialSettings={{
							// 		startDate: startDate ? startDate : carFinding.filter.startDate,
							// 		endDate: endDate ? endDate : carFinding.filter.endDate,
							// 		minDate: moment(),
							// 		maxDate: moment().add(3, "months"),
							// 		timePicker: true,
							// 		timePicker24Hour: true,
							// 		timePickerIncrement: 30,
							// 		singleDateRangePicker: false,

							// 		isIOs: isIOS,
							// 		template: calendarTemplate,
							// 		buttonClasses: ["btn btn--m btn-primary"],
							// 		locale: {
							// 			applyLabel: "Áp dụng",
							// 		},
							// 		opens: "center",
							// 		parentEl: "#home-sd",
							// 		linkedCalendars: true,
							// 		singelSelect: true,
							// 	}}
							// 	onHide={this.onDateRangeChange}>
							// 	<div className="time-form" style={{ position: "relative" }}>
							// 		<div className="time-form__item">
							// 			<div className="wrap-svg">
							// 				<IcCalendarSearch />
							// 			</div>

							// 			<div className="time-value">
							// 				{startDate
							// 					? startDate.format("DD/MM/YYYY")
							// 					: carFinding.filter.startDate.format("DD/MM/YYYY")}
							// 			</div>
							// 			<div className="line" />
							// 			<div className="time-value">
							// 				{startDate
							// 					? startDate.format("HH:mm")
							// 					: carFinding.filter.startDate.format("HH:mm")}
							// 			</div>
							// 		</div>
							// 		<div className="wrap-svg">
							// 			<IcNextCircle />
							// 		</div>
							// 		<div className="time-form__item">
							// 			<div className="time-value">
							// 				{endDate
							// 					? endDate.format("DD/MM/YYYY")
							// 					: carFinding.filter.endDate.format("DD/MM/YYYY")}
							// 			</div>
							// 			<div className="line" />
							// 			<div className="time-value">{endDate ? endDate.format("HH:mm") : "Chọn giờ"}</div>
							// 		</div>
							// 	</div>
							// </DateRangePicker> */}
						
					
					</div>

					{isCalendar && (
						<DateBox
							show={isCalendar}
							startDate={startDate}
							startTime={startTime}
							endDate={endDate}
							endTime={endTime}
							filter={carFinding.filter}
							finding={true}
							searchCar={searchCar}
							onDatesChange={onDateRangeChange}
							hideModal={hideCalendar}
							onStartTimeChange={onStartTimeChange}
							onEndTimeChange={onEndTimeChange}
							isMCalendar={false}
						/>
					)}
				</div>
			</div>
		</div>
	);
};

const mapState = (state) => {
	return {
		carFinding: state.carFinding,
	};
};

export default withRouter(connect(mapState)(QuicklySearch));
